export default __webpack_public_path__ + "static/media/StateAuto-logo.751b60a7.svg";